const defaultMeta = {
  roles: ['admin'],
};

export default {
  path: '/admin-panel',
  name: 'admin-panel',
  redirect: {
    name: 'users',
  },
  component: () => import(/* webpackChunkName: "admin-panel" */ '../views/AdminPanelPage.vue'),
  meta: {
    ...defaultMeta,
  },
  children: [
    {
      path: 'roles',
      name: 'roles',
      component: () => import(/* webpackChunkName: "roles" */ '../views/RolesPage.vue'),
      meta: {
        ...defaultMeta,
      },
    },
    {
      path: 'users',
      name: 'users',
      component: () => import(/* webpackChunkName: "users" */ '../views/UsersListPage.vue'),
      meta: {
        ...defaultMeta,
      },
    },
    {
      path: 'contacts',
      name: 'contacts',
      component: () => import(/* webpackChunkName: "contacts" */ '../views/ContactsListPage.vue'),
      meta: {
        ...defaultMeta,
      },
    },
    {
      path: 'project-types',
      name: 'project-types',
      component: () => import(/* webpackChunkName: "project-types" */ '../views/ProjectTypesListPage.vue'),
      meta: {
        ...defaultMeta,
      },
    },
    {
      path: 'features',
      name: 'features',
      component: () => import(/* webpackChunkName: "features" */ '../views/FeaturesListPage.vue'),
      meta: {
        ...defaultMeta,
      },
    },
    {
      path: 'plans',
      name: 'plans',
      component: () => import(/* webpackChunkName: "plans" */ '../views/PlansListPage.vue'),
      meta: {
        ...defaultMeta,
      },
    },
    {
      path: 'stages',
      name: 'stages',
      component: () => import(/* webpackChunkName: "stages" */ '../views/StagesListPage.vue'),
      meta: {
        ...defaultMeta,
      },
    },
    {
      path: '*',
      redirect: {
        name: 'users',
      },
    },
  ],
};
